/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lg_Guest_ActionInputs */

const en_lg_guest_action = /** @type {(inputs: Lg_Guest_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn about guest visits`)
};

const id_lg_guest_action = /** @type {(inputs: Lg_Guest_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajari kunjungan tamu`)
};

/**
* | output |
* | --- |
* | "Learn about guest visits" |
*
* @param {Lg_Guest_ActionInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const lg_guest_action = /** @type {((inputs?: Lg_Guest_ActionInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lg_Guest_ActionInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_lg_guest_action(inputs)
	return en_lg_guest_action(inputs)
});